var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"40","height":"28","viewBox":"0 6 40 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M40 6.667H0v26.667h40V6.667z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M15 6.666h-5V17.5H0v5h10v10.833h5V22.5h25v-5H15V6.666z","fill":"#F0F0F0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }